import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, isRef as _isRef, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-51711afe"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_2 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_4 = { class: "mt-10" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("新增打卡")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("更新")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("新增迟到早退")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("批量修正")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("确认考勤")
const _hoisted_10 = {
  key: 0,
  class: "mb-10"
}
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("修正")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("添加时段")
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-20" }, "备注：", -1))
const _hoisted_16 = {
  style: {"width":"100%"},
  class: "mt-10"
}
const _hoisted_17 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("考勤详情")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("扣款金额(元)")
const _hoisted_20 = { key: 1 }
const _hoisted_21 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("确认")

import { ref, reactive, onBeforeMount } from 'vue'
import eptBtn from '@/components/ExportButton.vue'
import dayjs from 'dayjs'
import { ElMessage, ElMessageBox } from 'element-plus'
import { getNumber } from '@/utils/index'
import tbMix, {userCfig} from '@/global_mixin/tableMixin'
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { 
  'POST/checkin/user': checkinUserApi,
  // 根据用户获取考勤信息
  'POST/checkin': checkinApi,
  // 团队
  'GET/organizations': orgListApi,
  // 员工列表(不分页,下拉框)
  'GET/users/list': userListApi,
  // 根据考勤id获取修正记录(多条)
  'GET/checkin_corrects': checkin_correctsApi,
  // 修正考勤
  'PATCH/checkin_corrects': justifyCheckinApi,
  // 对接企业微信获取考勤数据(更新月份考勤)
  'POST/checkin/add': checkinAddApi,
  // 修正记录删除
  'DELETE/checkin_corrects/{id}': checkin_correctsdelApi,
  // 导出考勤
  'POST/checkin/export': exportCheckinApi,
  // 确认考勤（个人）
  'PATCH/checkin/user_verify': user_verifyApi,
  // 获取所有公司
  'GET/company': companyApi,
  // 新增迟到早退
  'POST/checkin_lattes': checkin_lattesApi,
  // 新增打卡数据
  'POST/checkin/save': checkinSaveApi,
  // 删除考勤
  'DELETE/checkin/{id}': delCheckinIdApi,
  // 批量修正某天考勤数据
  'PATCH/checkin/batch_exception': batch_exceptionApi,
  // 个人扣款详情
  'POST/checkin/individual/deduct_money': deduct_moneyApi,
  // 导出打卡数据
  'POST/checkin/export_punchCard': export_punchCardApi,
  // 所有办公所在地
  'GET/house_leases': fullOfficeApi,
} = Api

const searchEle = ref()
const searchObj = reactive({
  key: '', date: dayjs().subtract(0, 'month').format('YYYY-MM-DD'),
  orgId: '', unusual: '', companyIds: []
})
// 获取公司下拉框数据
let fullUserList: any = ref([])
const searchConfig:any= ref([
  {
    label: '姓名',
    value: '',
    upKey: 'key',
    props: { clearable: true, precision: 0 },
  },
  {
    type: "TIME",
    label: "月份",
    value: dayjs().subtract(0, 'month').format('YYYY-MM') + '-01',
    upKey: 'date',
    props: {
      type: 'month',
      clearable: false,
      'value-format': 'YYYY-MM-DD'
    }
  },
  {
    type: 'SELECT',
    label: '团队',
    value: '',
    upKey: 'orgId',
    options: [],
    placeholder: '请选择团队',
    selectFunc: orgListApi,
    props: { clearable: true  },
    seleProps: {
      label: 'name',
      valueName: 'id',
    }
  },
  {
    type: 'SELECT',
    label: '异常情况',
    value: '',
    upKey: 'unusual',
    options: [
      {label: '异常情况', id: '异常情况'},
    ],
    placeholder: '请选择异常情况',
    props: { clearable: true },
    seleProps: { }
  },
  {
    type: 'SELECT',
    label: '公司',
    value: '',
    upKey: 'companyIds',
    selectFunc: companyApi,
    options: [],
    placeholder: '请选择公司',
    props: { clearable: true, multiple: true, 'collapse-tags': true, style: 'width: 350px' },
    seleProps: { 
      label: 'name',
      valueName: 'id',
    }
  },
])

let officeList: any = ref([])
onBeforeMount(() => {
  userListApi().then((_userList: object[]) => {
    fullUserList.value = _userList.map((_user: any) => {
      _user.label = `${_user.realName}(${_user.alias})`
      return _user
    })
  })

  fullOfficeApi().then((officeRep: any) => {
    officeList.value = officeRep;
  })
})

// 用户
const { 
  MI_tableData: userData, fetchData: fetchUser, page: userPage, size: userSize, MI_total: userTotal, MI_pageChange: userPageChange,
  MI_sizeChange: userSizeChange, MI_identify: userLoad, MI_params: user_params, MI_height, MI_modifyForm
} = new tbMix(checkinUserApi)

const lockby = ref<boolean>(false)
const searchHandle = async (params?: any) => {
  await fetchUser(searchObj)
  attendenceDetail.realName = null
  chData.value = []
  lockby.value = false
  attendenceDetail.isEmpty = true
  // 如果搜索结果只有一个用户，展示考勤详情
  if(userData.value.length === 1){
    checkinSearch({userId: userData.value[0].userId})
  }
}
searchHandle()

// 考勤
const { 
  MI_tableData: chData, fetchData: fetchCheckin,  MI_identify: checkLoad, MI_params: checkin_params
} = new tbMix(checkinApi)


// 点击用户，展示考勤
let attendenceUserId = ref<number>()
let attendenceDetail: any = reactive({isEmpty: true})
// 展示当前查看用户考勤数据
const checkinSearch = (row: any) => {
  attendenceUserId.value = row.userId
  fetchCheckin({
    userId: row.userId,
    date: user_params.date,
    unusual: user_params['unusual']
  }).then((rep) => {
    Object.assign(attendenceDetail, rep.summary, rep.detail || {leave: '', late: '', fullAttendance: '',}, {isEmpty: false}) 
    lockby.value = rep.lockBy === null ? true : false 
  })
}

// 时间格式化
const formatJudgment = (row: any, column: any, cellValue: number, index: number) => {
  if((dayjs(row.date).day() === 0 || dayjs(row.date).day() === 6) && 
  row.earliestTime === '00:00:00' &&
  row.lastestTime === '00:00:00' &&
  row.judgment === "正常") return '';
  return cellValue
}
const formatStartTime = (row: any, column: any, cellValue: number, index: number) => {
  if(!row.details) return '-';
  let arr = row.details.reduce((arr: Array<any>, _time: any) => {
    arr.push(_time.startTime)
    return arr
  }, [])
  arr.sort((a: string,b: string) => {
    return dayjs(a, 'HH:mm:ss').isBefore(dayjs(b, 'HH:mm:ss')) ? -1 : 1
  })
  if(arr.length === 0){
    return '-'
  }
  if(arr.length === 1 && arr[0] === '00:00:00'){
    return '00:00'
  }
  if(arr.length > 1 && arr[0] === '00:00:00'){
    return dayjs(arr[1], 'HH:mm:ss').format('HH:mm')
  }
  return dayjs(arr[0], 'HH:mm:ss').format('HH:mm')
  
}
const formatEndTime = (row: any, column: any, cellValue: number, index: number) => {
  if(row.details){

    let arr = row.details.reduce((arr: Array<any>, _time: any) => {
      _time.endTime !== '00:00:00' ? arr.push(_time.endTime) : arr.push('00:00:00')
      return arr
    }, [])
    arr.sort((a: string,b: string) => {
      return dayjs(a, 'HH:mm:ss').isBefore(dayjs(b, 'HH:mm:ss')) ? 1 : -1
    })
    
    return dayjs(arr[0], 'HH:mm:ss').format('HH:mm')
  }
  
  
  return '-'
}



// 修正考勤
let adjustRow: any = {}
const adjustFg = ref<boolean>(false)
const isEditLoad = ref<boolean>(false)
const adjustForm: any = reactive({
  attednRows: []
})
const addAttednRow = () => {
  adjustForm.attednRows.push({
    id: '',
    attendId: adjustRow.id,
    startTime: '',
    endTime: '',
    note: '',
    timeRange: [],
  })
}

const showEdit = (row: {id: number}) => {
  adjustRow = row
  checkLoad.value = true
  // 获取历史修正数据
  checkin_correctsApi({attendId: row.id}).then((rep: any) => {
    adjustForm.attednRows = rep.map((att: any) => {
      att.timeRange = [
        dayjs(att.startTime, 'HH:mm:ss').toDate(),
        dayjs(att.endTime, 'HH:mm:ss').toDate()
      ]
      return att
    })
    // 打开弹框
    adjustFg.value = true
  }).finally(() => {
    checkLoad.value = false
  })
}
// 删除考勤
const delAttend = (row: any) => {
  ElMessageBox.confirm(
    '是否删除?',
    '提示',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }
  )
  .then(() => {
    checkLoad.value = true
    return delCheckinIdApi({id: row.id})
  })
  .then(() => {
    ElMessage.success('删除成功')
    checkLoad.value = false
    checkinSearch({userId: attendenceUserId.value})

  })
  .catch(() => {
    checkLoad.value = false

  })
}

const adjustSubmit =  (row: any) => {

  if(row.timeRange.length <= 0 || !row.note){
    ElMessage.warning('时间或备注不能为空')
    return
  }

  isEditLoad.value = true
  justifyCheckinApi({
    ...row,
    // 时分秒处理
    startTime: dayjs(row.timeRange[0]).format('HH:mm:ss'),
    endTime: dayjs(row.timeRange[1]).format('HH:mm:ss'),
  }).then(() => {
    ElMessage.success('修正成功')
    isEditLoad.value = false
    checkinSearch(checkin_params)
  }).finally(() => {
    isEditLoad.value = false
  })
}
const delAjdust = async (row: any, index: number) => {

  if(row.id !== ''){
    await checkin_correctsdelApi({id: row.id})
    ElMessage.success('删除成功')
    adjustForm.attednRows.splice(index, 1);
    return
  }
  adjustForm.attednRows.splice(index, 1);
  
}

// 更新
const updataAtten = () => {
  checkinAddApi({date: user_params['date']})
  ElMessage(user_params['date'] + '数据成功更新')
  
}

// 个人确认考勤
const isShowConfirm = ref<boolean>(false)
let dudectObj: any = reactive({})
let balanceObj: any = reactive({})
const showConfirm =  () => {
  checkLoad.value = true
  deduct_moneyApi({
    date: checkin_params.date,
    userId: attendenceUserId.value,
  }).then(rep => {
    checkLoad.value = false
    Object.assign(dudectObj, rep.deduct)
    Object.assign(balanceObj, rep.balance)
    checkLoad.value = false
    isShowConfirm.value = true
  }).catch(() => {
    checkLoad.value = false
  })
}

const confirmHandle = async () => {
  isShowConfirm.value = false
  checkLoad.value = true
  try {
    await user_verifyApi({ userId: attendenceUserId.value, date: checkin_params.date })
    checkLoad.value = false
    ElMessage.success('确认成功')
    searchHandle()
  } catch (error) {
    checkLoad.value = false
  }
}

// 新增迟到早退
const lattersEle = ref()
const lattersFg = ref<boolean>(false)
const lattersFrom: any = reactive({
  userId: '',
  date: '',
  minute: undefined,
  category: '',
})
const lattesSubmit =  () => {
  lattersEle.value.validate(async (valid: boolean) => {
    if (valid) {
      await checkin_lattesApi(lattersFrom)
      lattersFg.value = false
      ElMessage.success('成功')
    } else {
      return false
    }
  })

}
// 新增打卡数据
const saveFg = ref<boolean>(false)
const saveConfig = ref([
  /* {
    type: 'SELECT',
    label: '员工',
    value: '',
    upKey: 'userId',
    rule: [
      { required: true, message: '请选择员工', trigger: 'change' },
    ],
    options: [],
    placeholder: '请选择员工',
    selectFunc: userListApi,
    props: { },
    seleProps: { label: 'realName', valueName: 'userId', },
  }, */
  userCfig(),
  {
    type: "TIME",
    label: "日期",
    value: '',
    upKey: 'date',
    props: { 'value-format': 'YYYY-MM-DD', clearable: true, },
    rule: [ { required: true, message: '请选择日期', trigger: 'change' }, ],
  },
  {
    type: "TIMESELECT",
    label: "早上打卡",
    value: '',
    upKey: 'earliestTime',
    props: { clearable: true, },
    rule: [ { required: true, message: '请选择早上打卡', trigger: 'change' }, ],
  },
  {
    type: "TIMESELECT",
    label: "下午打卡",
    value: '',
    upKey: 'lastestTime',
    props: { clearable: true, },
    rule: [{ required: true, message: '请选择下午打卡', trigger: 'change' }],
  },
  {
    label: "判断",
    value: '',
    upKey: 'judgment',
    props: {clearable: true}
  },
  {
    type: 'SELECT',
    label: '团队',
    value: '',
    upKey: 'orgId',
    options: [],
    placeholder: '请选择团队',
    selectFunc: orgListApi,
    props: {},
    seleProps: {label: 'name', valueName: 'id', },
    rule: [{required: true, message: '请选择团队', trigger: 'change' }],
  },
  {
    type: 'SELECT',
    label: '公司',
    value: '',
    upKey: 'companyId',
    options: [],
    placeholder: '请选择公司',
    selectFunc: companyApi,
    seleProps: {label: 'name', valueName: 'id' },
    props: {placeholder: '请选择公司', clearable: true },
    rule: [{required: true, message: '请选择公司', trigger: 'change' }],
  },
])
const addSave = () => {
  MI_modifyForm({}, saveConfig, saveFg, async (params: any) => {
    await checkinSaveApi(params)
    ElMessage.success('成功')
    saveFg.value = false
    searchHandle()
  })
}

// 批量修改
const batchModify = ref<boolean>(false)
const batchModifyConfig = ref([
  {
    type: 'SELECT',
    label: '团队',
    value: '',
    upKey: 'orgIds',
    options: [],
    placeholder: '请选择团队',
    selectFunc: orgListApi,
    props: {clearable: true, multiple: true, 'collapse-tags': true},
    seleProps: {label: 'name', valueName: 'id', },
  },
  {
    type: 'SELECT',
    label: '员工',
    value: [],
    upKey: 'userIds',
    options: fullUserList,
    props: { placeholder: '请选择员工', clearable: true, multiple: true, 'collapse-tags': true, style: 'width: 490px' },
    seleProps: {label: 'label',valueName: 'userId'}
  },
  {
    type: 'SELECT',
    label: '办公所在地',
    value: '',
    upKey: 'leaseId',
    options: officeList,
    props: { placeholder: '请选择办公所在地', clearable: true },
    seleProps: {label: 'alias',valueName: 'id'}
  },
  {
    type: "TIMESELECT",
    label: "修正上班",
    value: '',
    upKey: 'earliestTime',
    props: { clearable: true, },
    rule: [{ required: true, message: '请选择早上打卡', trigger: 'change' }, ],
  },
  {
    type: "TIMESELECT",
    label: "修正下班",
    value: '',
    upKey: 'lastestTime',
    props: { clearable: true, },
    rule: [{ required: true, message: '请选择下午打卡', trigger: 'change' }],
  },
  {
    type: "TIME",
    label: "日期",
    value: '',
    upKey: 'date',
    props: { 'value-format': 'YYYY-MM-DD', clearable: true, placeholder: '请选择日期' },
    rule: [ { required: true, message: '请选择日期', trigger: 'change' }, ],
  },
  {
    label: "备注",
    value: '',
    upKey: 'note',
    props: {clearable: true, type: 'textarea', style: 'width: 730px'}
  },
])
const batchModifyHandle = () => {
  MI_modifyForm({}, batchModifyConfig, batchModify, async (params: any) => {
    console.log(params);
    
    if(params.orgIds === '' && params.userIds.length === 0 ){
      ElMessage.warning('请至少选择一个员工或者团队')
      return
    }
    await batch_exceptionApi(params)
    ElMessage.success('成功')
    batchModify.value = false
    searchHandle()
  })
}

// ------------
const tableRowClassName = ({ row, rowIndex }: { row: any, rowIndex: number }) => {
  if ( 
    (dayjs(row.date).day() === 0 || dayjs(row.date).day() === 6) && 
    row.earliestTime === '00:00:00' && 
    row.lastestTime === '00:00:00' && 
    row.judgment === "正常") {
    return 'holiday-row'
  }
  return ''
}



return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_option_group = _resolveComponent("el-option-group")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_time_picker = _resolveComponent("el-time-picker")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_FlexibleForm = _resolveComponent("FlexibleForm")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _directive_permission = _resolveDirective("permission")!
  const _directive_decimal = _resolveDirective("decimal")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_collapse, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_collapse_item, { title: "点此搜索考勤" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form, {
              ref_key: "searchEle",
              ref: searchEle,
              model: _unref(searchObj),
              inline: "",
              class: "searchBg",
              disabled: _unref(userLoad) || _unref(checkLoad)
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "姓名:",
                  prop: "key"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _unref(searchObj).key,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(searchObj).key) = $event)),
                      clearable: "",
                      placeholder: "请输入姓名",
                      maxlength: "100",
                      class: "form-input"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "月份:",
                  prop: "date"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: _unref(searchObj).date,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(searchObj).date) = $event)),
                      "value-format": "YYYY-MM-DD",
                      type: "month",
                      placeholder: "请选择月份",
                      clearable: false
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "团队:",
                  prop: "orgId"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      placeholder: "请选择团队",
                      modelValue: _unref(searchObj).orgId,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(searchObj).orgId) = $event)),
                      filterable: "",
                      clearable: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.getters.sysOrganizations, (org) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            label: org.name,
                            value: org.id,
                            key: org.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "异常情况:",
                  prop: "unusual"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      placeholder: "请选择异常情况",
                      modelValue: _unref(searchObj).unusual,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(searchObj).unusual) = $event)),
                      clearable: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "异常情况",
                          value: "异常情况"
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "公司:",
                  prop: "companyIds"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _unref(searchObj).companyIds,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(searchObj).companyIds) = $event)),
                      placeholder: "请选择公司",
                      filterable: "",
                      clearable: "",
                      "collapse-tags": "",
                      multiple: "",
                      style: {"width":"350px"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.getters.sysCompany, (group) => {
                          return (_openBlock(), _createBlock(_component_el_option_group, {
                            label: group.label,
                            key: group.label
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.options, (comp) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  label: comp.name,
                                  value: comp.id,
                                  key: comp.id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 2
                          }, 1032, ["label"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _hoisted_1,
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (searchHandle()))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_2
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_button, {
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (searchEle.value.resetFields()))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_3
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model", "disabled"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_4, [
      _withDirectives((_openBlock(), _createBlock(_component_el_button, {
        onClick: _cache[7] || (_cache[7] = ($event: any) => (addSave())),
        disabled: _unref(userLoad) || _unref(checkLoad),
        type: "primary"
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }, 8, ["disabled"])), [
        [_directive_permission, void 0, "checkin"]
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_el_button, {
        onClick: _cache[8] || (_cache[8] = ($event: any) => (updataAtten())),
        disabled: _unref(userLoad) || _unref(checkLoad),
        type: "primary"
      }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      }, 8, ["disabled"])), [
        [_directive_permission, void 0, "checkin"],
        [_directive_decimal]
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_el_button, {
        onClick: _cache[9] || (_cache[9] = ($event: any) => (lattersFg.value = true)),
        plain: "",
        disabled: _unref(userLoad) || _unref(checkLoad),
        type: "primary"
      }, {
        default: _withCtx(() => [
          _hoisted_7
        ]),
        _: 1
      }, 8, ["disabled"])), [
        [_directive_permission, void 0, "checkin"]
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_el_button, {
        onClick: batchModifyHandle,
        disabled: _unref(userLoad) || _unref(checkLoad),
        type: "primary"
      }, {
        default: _withCtx(() => [
          _hoisted_8
        ]),
        _: 1
      }, 8, ["disabled"])), [
        [_directive_permission, void 0, "checkin"]
      ]),
      (lockby.value)
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            onClick: _cache[10] || (_cache[10] = ($event: any) => (showConfirm())),
            disabled: _unref(userLoad) || _unref(checkLoad),
            type: "success"
          }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          }, 8, ["disabled"]))
        : _createCommentVNode("", true),
      _createVNode(_component_el_tooltip, {
        effect: "dark",
        content: "请先搜索后，再导出",
        placement: "top"
      }, {
        default: _withCtx(() => [
          _withDirectives(_createVNode(eptBtn, {
            exportFn: _unref(exportCheckinApi),
            exportText: '导出考勤',
            exportParam: _unref(user_params),
            disabled: _unref(userLoad) || _unref(checkLoad)
          }, null, 8, ["exportFn", "exportParam", "disabled"]), [
            [_directive_permission, void 0, "checkin"]
          ])
        ]),
        _: 1
      }),
      _createVNode(eptBtn, {
        exportFn: _unref(export_punchCardApi),
        exportText: '导出打卡数据',
        exportParam: _unref(user_params),
        disabled: _unref(userLoad) || _unref(checkLoad)
      }, null, 8, ["exportFn", "exportParam", "disabled"])
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_row, {
      gutter: 20,
      class: "mt-10"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, {
          span: 6,
          class: "table"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table, {
              ref: "tb",
              border: "",
              data: _unref(userData),
              "max-height": _unref(MI_height) - 75 + 'px'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  label: "姓名(单击查看)",
                  prop: "realName"
                }, {
                  default: _withCtx(({ row }) => [
                    _createVNode(_component_el_link, {
                      onClick: ($event: any) => (checkinSearch(row)),
                      type: "primary"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(`${row.realName}(${row.alias})`), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data", "max-height"]),
            _createVNode(_component_el_pagination, {
              class: "mt-10",
              total: _unref(userTotal),
              small: "",
              currentPage: _unref(userPage),
              "onUpdate:currentPage": _cache[11] || (_cache[11] = ($event: any) => (_isRef(userPage) ? (userPage).value = $event : null)),
              "page-size": _unref(userSize),
              "onUpdate:page-size": _cache[12] || (_cache[12] = ($event: any) => (_isRef(userSize) ? (userSize).value = $event : null)),
              "page-sizes": [ 30, 50, 100, 300, 600],
              layout: "pager, jumper",
              style: {"float":"none"},
              onCurrentChange: _unref(userPageChange),
              onSizeChange: _unref(userSizeChange)
            }, null, 8, ["total", "currentPage", "page-size", "onCurrentChange", "onSizeChange"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, {
          span: 18,
          class: "table"
        }, {
          default: _withCtx(() => [
            (_unref(attendenceDetail).realName)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createVNode(_component_el_descriptions, {
                    title: "",
                    border: "",
                    column: 5
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_descriptions_item, { label: "姓名" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(attendenceDetail).realName ? `${_unref(attendenceDetail).realName}(${_unref(attendenceDetail).alias})` : ''), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_descriptions_item, { label: "应到天数" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(attendenceDetail).shouldDays), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_descriptions_item, { label: "实到办公室天数" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(attendenceDetail).realDays), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_descriptions_item, { label: "出差天数" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(attendenceDetail).travelDays), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_descriptions_item, { label: "在家办公" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(attendenceDetail).workHomeDays), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_descriptions_item, { label: "请假天数" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(attendenceDetail).leaveDays), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_descriptions_item, { label: "考勤确认状态" }, {
                        default: _withCtx(() => [
                          (!_unref(attendenceDetail).isEmpty)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(lockby.value ? '未确认' : '已确认'), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_descriptions_item, { label: "迟到分钟" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(attendenceDetail).late), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_descriptions_item, { label: "缺勤(分钟)" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(attendenceDetail).leave), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_descriptions_item, { label: "全勤状态" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_tag, { size: "small" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(attendenceDetail).fullAttendance ? '全勤' : '非全勤'), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_el_table, {
              border: "",
              data: _unref(chData),
              "max-height": _unref(MI_height) - 135 + 'px',
              "row-class-name": tableRowClassName
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  label: "操作",
                  width: "100"
                }, {
                  default: _withCtx(({ row }) => [
                    _createVNode(_component_el_space, null, {
                      default: _withCtx(() => [
                        _withDirectives((_openBlock(), _createBlock(_component_el_link, {
                          type: "primary",
                          onClick: ($event: any) => (showEdit(row))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_12
                          ]),
                          _: 2
                        }, 1032, ["onClick"])), [
                          [_directive_permission, void 0, "checkin"]
                        ]),
                        _withDirectives((_openBlock(), _createBlock(_component_el_link, {
                          type: "danger",
                          onClick: ($event: any) => (delAttend(row))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_13
                          ]),
                          _: 2
                        }, 1032, ["onClick"])), [
                          [_directive_permission, void 0, "checkin"]
                        ])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "日期",
                  prop: "date",
                  width: "130",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "上班",
                  prop: "earliestTime"
                }, {
                  default: _withCtx(({ row }) => [
                    _createTextVNode(_toDisplayString(row.earliestTime === '00:00:00' ? '' : _unref(dayjs)(row.earliestTime, 'HH:mm:ss').format('HH:mm')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "下班",
                  prop: "lastestTime"
                }, {
                  default: _withCtx(({ row }) => [
                    _createTextVNode(_toDisplayString(row.lastestTime === '00:00:00' ? '' : _unref(dayjs)(row.lastestTime, 'HH:mm:ss').format('HH:mm')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "修正上班",
                  width: "100",
                  formatter: formatStartTime
                }),
                _createVNode(_component_el_table_column, {
                  label: "修正下班",
                  width: "100",
                  formatter: formatEndTime
                }),
                _createVNode(_component_el_table_column, {
                  label: "判定",
                  prop: "judgment",
                  formatter: formatJudgment,
                  width: "470",
                  "show-overflow-tooltip": ""
                })
              ]),
              _: 1
            }, 8, ["data", "max-height"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })), [
      [_directive_loading, _unref(userLoad) || _unref(checkLoad)]
    ]),
    _createVNode(_component_el_dialog, {
      title: "修正",
      width: "1000",
      modelValue: adjustFg.value,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((adjustFg).value = $event))
    }, {
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createElementBlock("div", null, [
          _createVNode(_component_el_button, {
            type: "primary",
            icon: "Plus",
            onClick: addAttednRow
          }, {
            default: _withCtx(() => [
              _hoisted_14
            ]),
            _: 1
          }),
          _createVNode(_component_el_form, {
            ref: "adjustRef",
            model: _unref(adjustForm),
            inline: true
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(adjustForm).attednRows, (attRow, index) => {
                return (_openBlock(), _createBlock(_component_el_form_item, { label: "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_divider, { "content-position": "left" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(`时段${index + 1}`), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_el_time_picker, {
                      "is-range": "",
                      modelValue: attRow.timeRange,
                      "onUpdate:modelValue": ($event: any) => ((attRow.timeRange) = $event),
                      "range-separator": "至",
                      "start-placeholder": "开始时间",
                      "end-placeholder": "结束时间"
                    }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                    _hoisted_15,
                    _createVNode(_component_el_input, {
                      modelValue: attRow.note,
                      "onUpdate:modelValue": ($event: any) => ((attRow.note) = $event),
                      placeholder: "请输入备注",
                      style: {"width":"260px"},
                      maxlength: "300"
                    }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                    _createElementVNode("div", _hoisted_16, [
                      _createVNode(_component_el_button, {
                        type: "danger",
                        icon: "Delete",
                        onClick: ($event: any) => (delAjdust(attRow, index))
                      }, null, 8, ["onClick"]),
                      _createVNode(_component_el_button, {
                        type: "success",
                        icon: "Check",
                        onClick: ($event: any) => (adjustSubmit(attRow))
                      }, null, 8, ["onClick"])
                    ])
                  ]),
                  _: 2
                }, 1024))
              }), 256))
            ]),
            _: 1
          }, 8, ["model"])
        ])), [
          [_directive_loading, isEditLoad.value]
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: lattersFg.value,
      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((lattersFg).value = $event)),
      onClose: _cache[19] || (_cache[19] = ($event: any) => (lattersEle.value.resetFields())),
      title: "新增迟到早退"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: lattesSubmit
        }, {
          default: _withCtx(() => [
            _hoisted_17
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref_key: "lattersEle",
          ref: lattersEle,
          model: _unref(lattersFrom),
          inline: true
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              rules: [{ required: true, message: '请选择员工', trigger: 'change', }],
              label: "迟到或早退员工:",
              prop: "userId"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(lattersFrom).userId,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(lattersFrom).userId) = $event)),
                  placeholder: "可输入搜索员工",
                  filterable: "",
                  clearable: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(fullUserList), (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.value,
                        label: item.label,
                        value: item.userId
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              rules: [{ required: true, message: '请输入迟到或早退分钟', trigger: 'change', }],
              label: "分钟:",
              prop: "minute"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input_number, {
                  controls: false,
                  min: 1,
                  modelValue: _unref(lattersFrom).minute,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(lattersFrom).minute) = $event)),
                  placeholder: "迟到或早退分钟",
                  clearable: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              rules: [{ required: true, message: '请选择日期', trigger: 'change', }],
              label: "日期:",
              prop: "date"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: _unref(lattersFrom).date,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_unref(lattersFrom).date) = $event)),
                  type: "date",
                  clearable: "",
                  placeholder: "迟到或早退日期",
                  "value-format": "YYYY-MM-DD"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              rules: [{ required: true, message: '请选择类型', trigger: 'change', }],
              label: "类型:",
              prop: "category"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(lattersFrom).category,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_unref(lattersFrom).category) = $event)),
                  placeholder: "迟到或早退",
                  clearable: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "迟到",
                      value: "Late"
                    }),
                    _createVNode(_component_el_option, {
                      label: "早退",
                      value: "LeaveEarly"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "添加",
      modelValue: saveFg.value,
      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((saveFg).value = $event))
    }, {
      default: _withCtx(() => [
        (saveFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
        searchConfig: saveConfig.value,
        submitText: '确定'
      })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      draggable: "",
      width: "850px",
      title: "批量修改",
      modelValue: batchModify.value,
      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((batchModify).value = $event))
    }, {
      default: _withCtx(() => [
        (batchModify.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
        searchConfig: batchModifyConfig.value,
        submitText: '确定'
      })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "考勤确认",
      width: "600px",
      modelValue: isShowConfirm.value,
      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((isShowConfirm).value = $event))
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[22] || (_cache[22] = ($event: any) => (isShowConfirm.value = false))
        }, {
          default: _withCtx(() => [
            _hoisted_21
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "success",
          onClick: _cache[23] || (_cache[23] = ($event: any) => (confirmHandle()))
        }, {
          default: _withCtx(() => [
            _hoisted_22
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_divider, { "content-position": "left" }, {
          default: _withCtx(() => [
            _hoisted_18
          ]),
          _: 1
        }),
        (_unref(dudectObj).totalAmount != 0)
          ? (_openBlock(), _createBlock(_component_el_descriptions, {
              key: 0,
              title: "",
              border: "",
              column: 1
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_descriptions_item, { label: "扣款项目" }, {
                  default: _withCtx(() => [
                    _hoisted_19
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, {
                  label: '迟到早退(分钟):' + _unref(dudectObj).earlyLate
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(getNumber)(_unref(dudectObj).earlyLateAmount)), 1)
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_descriptions_item, {
                  label: '试用期病假(小时):' + _unref(dudectObj).periodSickHour
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(getNumber)(_unref(dudectObj).periodSickAmount)), 1)
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_descriptions_item, {
                  label: '试用期事假(小时):' + _unref(dudectObj).periodCompassionateHour
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(getNumber)(_unref(dudectObj).periodCompassionateAmount)), 1)
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_descriptions_item, {
                  label: '转正病假(小时):' + _unref(dudectObj).regularSickHour
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(getNumber)(_unref(dudectObj).regularSickAmount)), 1)
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_descriptions_item, {
                  label: '转正事假(小时):' + _unref(dudectObj).regularCompassionateHour
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(getNumber)(_unref(dudectObj).regularCompassionateAmount)), 1)
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_descriptions_item, { label: "总扣款(元)" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(getNumber)(_unref(dudectObj).totalAmount)), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : (_openBlock(), _createElementBlock("div", _hoisted_20, "本月暂无扣款")),
        _createVNode(_component_el_divider, { "content-position": "left" }, {
          default: _withCtx(() => [
            _createTextVNode("截止至" + _toDisplayString(_unref(dayjs)().format('YYYY-MM-DD')) + " 剩余假期详情", 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_descriptions, {
          title: "",
          border: "",
          column: 1
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_descriptions_item, { label: "年假剩余" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(balanceObj).annualDay <= 0 ? 0 : _unref(balanceObj).annualDay) + "天", 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "可预支年假" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(balanceObj).annualDay > 0 ? _unref(balanceObj).surplusLimit : (_unref(balanceObj).surplusLimit + _unref(balanceObj).annualDay).toFixed(2)) + "天", 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, {
              label: '调休假已过期：' + _unref(balanceObj).invailed / 8 + '(天)'
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(balanceObj).invailed) + "小时", 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_descriptions_item, {
              label: '调休假总剩余：' + _unref(balanceObj).adjustDay / 8 + '(天)'
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(balanceObj).adjustDay) + "小时", 1)
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_alert, {
          class: "mt-10",
          title: "请仔细核对考勤信息。若有任何疑问，及时联系HR核实。若无误，请点击确认键",
          type: "warning",
          effect: "dark",
          closable: false
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})